<template>
  <div id="subOutputRank-print" class="page-break">
    <el-row>
      <el-col :span="18" :offset="2">
        <!-- <h1 style="text-align: center;margin-top: 0;padding-top: 0;color: #000">{{printTitle}}</h1> -->
        <h1 style="text-align: center; margin-top: 0; padding-top: 0; color: #000">
          {{ this.companyName }}入库单
        </h1>
      </el-col>
    </el-row>
    <el-row>
    <el-col v-if="topData.length > 0" :span="18">
        <ul>
          <li>
            供&nbsp;&nbsp;应&nbsp;&nbsp;商：{{ topData[0].SUPPLIER_NAME }}
          </li>
          <li>订&nbsp;单&nbsp;编号：{{ topData[0].ORDER_CODE }}</li>
          <li>整&nbsp;单&nbsp;备注：{{ topData[0].REMARKS }}</li>
        </ul>
      </el-col>
      <el-col :span="6">
        <ul>
          <li>送&nbsp;货&nbsp;日&nbsp;期：{{ topData[0].SEND_DAY }}</li>
          <li>制&nbsp;&nbsp;&nbsp;单&nbsp;&nbsp;人：{{ this.preparer }}</li>
        </ul>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="22" style="position:relative;">
        <table style="width: 100%">
          <tr>
            <th style="width: 5%">序号</th>
            <th style="width: 30%">名称</th>
            <th style="width: 5%">单位</th>
            <th style="width: 10%" v-if="printCode == 1">产品编码</th>
            <th style="width: 10%">单价</th>
            <th style="width: 10%">入库数量</th>
            <th style="width: 10%">入库金额</th>
            <th style="width: 10%">产品备注</th>
          </tr>
          <tr v-for="(item, index) in mainData[0]" :key="index">
            <td>{{ item.ID }}</td>
            <td>{{ item.AFTER_NAME }}</td>
            <td>{{ item.AFTER_TYPE_UNIT }}</td>
            <td v-if="printCode == 1">{{ item.AFTER_PRODUCT_CODE }}</td>
            <td>{{ item.AFTER_PRICE }}</td>
            <td>{{ item.AFTER_COUNT }}</td>
            <td>{{ item.WORTH }}</td>
            <td>{{ item.PRODUCT_COMMENT }}</td>
          </tr>
        </table>
      </el-col>
      <div style=" position:absolute;right:6%;display:flex;flex-direction: column;font-size:0;" v-if="tcId == 4097">
        <span style="font-size:15px; line-height:20px;">白</span>
        <span style="font-size:15px; line-height:20px;">联</span>
        <span style="font-size:15px; line-height:20px;">财</span>
        <span style="font-size:15px; line-height:20px;">务</span>
        <div style="height:5px;"> </div>
        <span style="font-size:15px; line-height:20px;">红</span>
        <span style="font-size:15px; line-height:20px;">联</span>
        <span style="font-size:15px; line-height:20px;">存</span>
        <span style="font-size:15px; line-height:20px;">根</span>
        <div style="height:5px;"></div>
        <span style="font-size:15px; line-height:20px;">黄</span>
        <span style="font-size:15px; line-height:20px;">联</span>
        <!-- <span style="font-size:15px; line-height:20px;">领</span>
        <span style="font-size:15px; line-height:20px;">料</span>
        <span style="font-size:15px; line-height:20px;">/</span> -->
        <span style="font-size:15px; line-height:20px;">仓</span>
        <span style="font-size:15px; line-height:20px;">库</span>
        <!-- <span style="font-size:15px; line-height:20px;">/</span>
        <span style="font-size:15px; line-height:20px;">客</span>
        <span style="font-size:15px; line-height:20px;">户</span> -->
      </div>
    </el-row>
    <el-row>
      <el-col :span="12">
        <p>入库时间：</p>
      </el-col>
      <el-col :span="6">
        <p>入库单总金额：{{ this.sum }}</p>
      </el-col>
    </el-row>
    <el-row v-if="tcId      ==      5903">
      <el-col :span="8">
        <p>收货人：</p>
      </el-col>
    </el-row>
    <el-row v-else>
      <!-- <el-col :span="6">
                <p>制单人：</p>
            </el-col>
            <el-col :span="6">
                <p>验收人：</p>
            </el-col>
            <el-col :span="6">
                <p>确认人：</p>
            </el-col>
            <el-col :span="6">
                <p>审核人：</p>
            </el-col> -->
      <el-col :span="8">
        <p>主管：</p>
      </el-col>
      <!-- <el-col :span="6" v-if="topData[0].GYS_ID !== 4097">
        <p>会计：</p>
      </el-col> -->
      <el-col :span="8">
        <p>验收：</p>
      </el-col>
      <el-col :span="8">
        <p>制单：</p>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="3" :offset="21" style="padding: 0">
        <p>第{{ mainData[0].currentPage }}页/共{{ mainData[0].totalPage }}页</p>
      </el-col>
    </el-row>
  </div>
</template>
<script type="text/ecmascript-6">
export default {
  props: {
    tableData: {
      type: Array,
      default() {
        return [];
      },
      required: true,
    },
    headerData: {
      type: Array,
      default() {
        return [];
      },
      required: true,
    },
    manager: String,
    supplier: String,
    title: String,
    IsPrintCode: String,
  },
  data() {
    return {
      topData: [],
      mainData: [],
      managername: '',
      imgUrl: '',
      printSupplier: '',
      printTitle: '',
      companyName: '',
      preparer: '',
      sum: 0,
      tcId: '',
      printCode: '',
    };
  },
  created() {
    this.topData = this.headerData;
    this.mainData.push(this.tableData);
    this.managername = this.manager;
    this.printSupplier = this.supplier;
    this.printTitle = this.title;
    this.printCode = this.IsPrintCode;
    this.imgUrl = `https://service.linkda.com.cn/file/barcode/${this.topData[0].ORDER_ID}.png`;
    // this.imgUrl = 'http://47.99.59.146/file/barcode/'+ this.topData[0].ORDER_ID + '.png'
    this.companyName = sessionStorage.getItem('company');
    this.tcId = sessionStorage.getItem('tcId');
    this.preparer = sessionStorage.getItem('name');
    this.tableData.forEach((item) => {
      this.sum += Number(item.WORTH);
    });
    this.sum = this.sum.toFixed(2);
  },
};
</script>
<style scoped>
ul {
  margin-top: 0;
  padding-top: 0;
  padding-left: 0;
}

li {
  list-style: none;
  font-size: 20px;
  line-height: 30px;
  color: #000;
  font-family: 黑体;
}

span {
  font-size: 20px;
  line-height: 35px;
  color: #000;
  font-family: 黑体;
}

p {
  font-size: 20px;
  line-height: 35px;
  color: #000;
  font-family: 黑体;
}

table {
  border-collapse: collapse;
  width: 130%;
  border: 1px solid #000;
  font-weight: bold;
}

td,
th {
  border: 1px solid #000;
  text-align: center;
  font-weight: normal;
  font-size: 22px;
  height: 30px;
  font-family: 黑体;
  color: #000;
}
</style>



// WEBPACK FOOTER //
// src/components/shopOrderManage/s_historyPrint.vue